<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="addSelected" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="selected.length >= 1" :vm-active="isProductsModalVisible" :vm-title="$t('strings.select_products')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(multiple v-model="selected" max-height="350px" :data="products")
          template(slot="header")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('label_groups.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column != 'code' && column != 'name' && column != 'description' && column != 'quantity' && column != 'products_by_label'") {{data[indextr][column]}}
                slot(v-if="column == 'code'")  {{ data[indextr][column] }}
                slot(v-if="column == 'name'")  {{ data[indextr][column] }}
                slot(v-if="column == 'description'")  {{ data[indextr][column] }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')

export default {
  name: 'ModalLabelProducts',
  mixins: [ModalMixin1],
  data: () => ({
    selected: [],
    columns: [
      'code',
      'name',
      'description'
    ]
  }),
  computed: {
    ...mapGetters(['isProductsModalVisible', 'products'])
  },
  methods: {
    ...mapActions([
      'addLabels',
      'setProductsModalVisible'
    ]),
    addSelected () {
      this.addLabels(this.selected)
      this.setProductsModalVisible(false)
      this.selected = []
    },
    close () {
      this.setProductsModalVisible(false)
    }
  }
}
</script>
